import { Keyboard } from 'react-native'
import { useEffect, useState } from 'react'

export const useKeyborad = () => {
	//variable to handle keyboard activity
	const [keyboardOpen, setKeyboardOpen] = useState(false)

	// initial useEffect when page is focused
	useEffect(() => {
		const open = Keyboard.addListener("keyboardDidShow", () => {
			setKeyboardOpen(true);
		});
		const close = Keyboard.addListener("keyboardDidHide", () => {
			setKeyboardOpen(false);
		});

		return () => {
			open?.remove()
			close?.remove()
		}
	}, [])
	return keyboardOpen
}